export type MarketCapTier = "small" | "mid" | "large"

export const MARKET_CAP_TIER_LABELS: Record<MarketCapTier, string> = {
  small: "小型株",
  mid: "中型株",
  large: "大型株",
}

// 東証(JPX)の公式区分(TOPIX Core30/Large70/Mid400/Small)は「全上場銘柄中の
// 時価総額・流動性順位」で決まり、絶対額のしきい値ではない — このアプリは
// 自社がクロールした一部の銘柄のデータしか持たないため、全銘柄中の順位を
// 算出できず採用できない。代わりに、証券会社・金融メディアで目安として
// よく使われる金額区分（時価総額1,000億円以下=小型株、1,000億〜5,000億円
// =中型株、5,000億円以上=大型株）を採用する。法律上の統一基準ではない
// 一般的な目安である旨は/disclaimerに明記する。
const LARGE_CAP_THRESHOLD = 500_000_000_000 // 5,000億円
const MID_CAP_THRESHOLD = 100_000_000_000 // 1,000億円

export function marketCapTierFromValue(marketCap: number | null): MarketCapTier | null {
  if (marketCap == null) return null
  if (marketCap >= LARGE_CAP_THRESHOLD) return "large"
  if (marketCap >= MID_CAP_THRESHOLD) return "mid"
  return "small"
}
